import { useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Column, useTable, usePagination } from "react-table";
import ReactHtmlParser from "react-html-parser";
import Cookies from "js-cookie";

import { useGetRateCardDetails } from "api/queries/rate-card/useGetRateCardDetails";
import { useIntl } from "react-intl";
import DataTable from "components/organisms/DataTable/DataTable";
import { replaceLinebreaks } from "helpers/commonHelpers";

const lanesDataSelector = (data: any) => data?.lanes || [];

function RateCardLanes() {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const queryPage = +(searchParams.get("page") || 0);
  const { id } = useParams();
  const { data } = useGetRateCardDetails(id as string, { refetchOnMount: false, select: lanesDataSelector });

  const columns = useMemo<Column[]>(
    () => [
      {
        Header: intl.formatMessage({
          id: "general.name",
          defaultMessage: "Name",
        }),
        accessor: "name",
        Cell: ({ value }: any) => <div>{value || "-"}</div>,
      },
      {
        Header: intl.formatMessage({
          id: "settings.rate-cards.pickupType",
          defaultMessage: "Pickup Type",
        }),
        accessor: "pickup_restriction.type",
        Cell: ({ value }: any) => <div className="text-capitalize">{value || "-"}</div>,
      },
      {
        Header: intl.formatMessage({
          id: "general.origin",
          defaultMessage: "Origin",
        }),
        accessor: "pickup_restriction.country",
        Cell: ({ value }: any) => <div>{value || "-"}</div>,
      },
      {
        Header: intl.formatMessage({
          id: "settings.rate-cards.originRestriction",
          defaultMessage: "Origin Restriction",
        }),
        accessor: "pickup_restriction.restriction",
        Cell: ({ value }: any) => <div>{ReactHtmlParser(replaceLinebreaks(value || "-"))}</div>,
      },
      {
        Header: intl.formatMessage({
          id: "settings.rate-cards.destinationType",
          defaultMessage: "Destination Type",
        }),
        accessor: "destination_restriction.type",
        Cell: ({ value }: any) => <div className="text-capitalize">{value || "-"}</div>,
      },
      {
        Header: intl.formatMessage({
          id: "general.destination",
          defaultMessage: "Destination",
        }),
        accessor: "destination_restriction.country",
        Cell: ({ value }: any) => <div>{value || "-"}</div>,
      },
      {
        Header: intl.formatMessage({
          id: "settings.rate-cards.destinationRestriction",
          defaultMessage: "Destination Restriction",
        }),
        accessor: "destination_restriction.restriction",
        Cell: ({ value }: any) => <div>{ReactHtmlParser(replaceLinebreaks(value || "-"))}</div>,
      },
    ],
    [],
  );

  const instance = useTable(
    {
      initialState: {
        pageSize: +(Cookies.get("listing_sizeperpage") || 10),
        pageIndex: queryPage ? queryPage - 1 : 0,
      },
      columns,
      data,
    },
    usePagination,
  );

  useEffect(() => {
    instance.gotoPage(queryPage ? queryPage - 1 : 0);
  }, [queryPage]);

  return (
    <div>
      <DataTable autoPagination tableInstance={instance} totalData={data.length} isLoading={false} draggable={false} />
    </div>
  );
}

export default RateCardLanes;
